import { Stack, Typography } from '@mui/material'
import React from 'react'

import { MUIExternalLink } from 'components/common/MUIExternalLink'
import PageSection from 'components/common/PageSection'
import { PrivateNetworkIntegrationsList } from 'components/configurations/private-network-integrations/PrivateNetworkIntegrationsList'
import Icon from 'components/Icon'
import useAuth from 'hooks/use-auth'
import { useGetTeams } from 'hooks/use-get-teams-paged'
import { useGetIntegrationClients } from 'queries/integration-clients/use-get-integration-clients'
import { PrivateNetworkIntegrationScope } from 'types/api/rbac/company'
import { messageFromResponseError } from 'utils/strings'

export const PrivateNetworkIntegrationsPage: React.FC = () => {
  const { companyPrefs } = useAuth()

  const {
    data: integrationClients,
    isLoading: isLoadingIntegrationClients,
    isError: hasErrorIntegrationClients,
    error: integrationClientsError
  } = useGetIntegrationClients()

  const {
    data: teams,
    isFetching: isFetchingTeams,
    isError: isErrorTeams
  } = useGetTeams()

  const { pni_scope: pniScope } = companyPrefs

  return (
    <PageSection
      errorMessage={messageFromResponseError(
        integrationClientsError,
        'We encountered an error while fetching Private Network Integrations. Please try again later.'
      )}
      hasError={hasErrorIntegrationClients || isErrorTeams}
      isLoading={isLoadingIntegrationClients || isFetchingTeams}
    >
      {integrationClients && teams && (
        // TODO: useFlexGap
        <Stack sx={{ rowGap: 4 }}>
          <Stack
            data-testid="private-network-integrations-page-header"
            sx={{ rowGap: 2 }}
          >
            <Typography>
              Private Network Integrations (PNIs) allow you to use Health Checks
              and Webhooks without exposing your internal network endpoints to
              the public internet. Your company currently shares PNIs across{' '}
              <Typography component="span" sx={{ fontWeight: 'bold' }}>
                {pniScope === PrivateNetworkIntegrationScope.Team
                  ? 'each team'
                  : 'the company'}
              </Typography>
              .{' '}
              <MUIExternalLink href="https://www.gremlin.com/docs/platform-integration-agent">
                Learn more about PNIs <Icon icon="arrowUpRightFromSquare" />
              </MUIExternalLink>
            </Typography>
          </Stack>
          <PrivateNetworkIntegrationsList
            integrationClients={integrationClients}
            teams={teams}
          />
        </Stack>
      )}
    </PageSection>
  )
}
